import { render, staticRenderFns } from "./server-change-password.vue?vue&type=template&id=422fd718&scoped=true&"
import script from "./server-change-password.vue?vue&type=script&lang=js&"
export * from "./server-change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fd718",
  null
  
)

export default component.exports